import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=af5736dc&scoped=true&"
import script from "./UserIndex.vue?vue&type=script&lang=ts&"
export * from "./UserIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5736dc",
  null
  
)

export default component.exports